import { ReportFeatures } from '@hcs/types';

export const COMP_COMPARE_COLUMN_FEATURES_SALE = [ReportFeatures.CompsSelect];
export const COMP_COMPARE_COLUMN_FEATURES_RENTAL = [
  ReportFeatures.RentalCompsSelect,
];
